// UI texts: end of a session, the screen after sending a survivor out (CHANGELOG 6.8)
export default {
  docTitle: 'Out there · AFTER DAY',
  back: 'Back in',
  at: 'back at {t}',
  reportWaits: 'The report will be waiting when you come back.',
  alsoReady: 'Also done while they are away',
  in: 'in {t}',
  kinds: { craft: 'Workshop', building: 'Camp', scout: 'Scavengers', energy: 'Energy' },
  /** Krug 5 (K12.11). */
  ate: 'Ate: {name}',
  contract: 'Contract runs out',
  contractEnds: 'ends in {t}',
  weekly: 'Weekly',
  rumor: 'New rumor · {zone}',
  reliability: 'Reliability {n} of 3',
  notify: {
    /** Package 4, part A.3: asked on a new account's first run of 20 minutes or more. */
    pingTitle: '{name} will be back in {t}. Want a ping?',
    pingBody: 'One ping when the report is ready. Timers are grouped: at most one every 30 minutes.',
    pingYes: 'Ping me',
    later: 'Not now',
    title: 'Get a ping when {name} is back',
    body: 'Timers are grouped: at most one ping every 30 minutes.',
    button: 'Turn on notifications',
    on: 'Notifications are on',
    blocked: 'Notifications are blocked in this browser. Allow them in the site settings.',
    unsupported: 'This browser cannot show notifications.',
    telegram: 'Pings come through the Telegram bot',
    bot: 'Open @{bot} for pings',
  },
  camp: 'Back to camp',
  watch: 'Watch the run',
} as const;
